export enum ProcessInfoIdentifier {
  UIDataStoreCreate = 'ui-data-store-create',
  ProjectModelFieldsCreate = 'project-model-fields-create',
  DataSchemaFieldsCreate = 'data-schema-fields-create',
  ProjectModelEndpointsCreate = 'project-model-endpoints-create',
  ProjectCreate = 'project-create',
  ProjectModelRelation = 'project-model-relation-create',
  AIOrchestration = 'ai-orchestration'
}
